(function() {
    var _model = Backbone.Model.extend({
        defaults: {
            GiftMessage: undefined,
            GiftMessageEdit: undefined,

            GiftDate: undefined,

            GiftDateDay: undefined,
            GiftDateMonth: undefined,
            GiftDateYear: undefined,

            GiftDateEditDay: undefined,
            GiftDateEditMonth: undefined,
            GiftDateEditYear: undefined,

            GiftOccasion: undefined,
            GiftOccasionEdit: undefined,

            GiftStyle: undefined
        },

        initialize: function () {
            _.bindAll(this, '_update', 'save', '_saved');
            app.checkout.orderXhr.done(this._update);
            app.checkout.onUpdate(this._update);
        },

        getGiftMessage: function() {
            return this.get('GiftMessageEdit') || '';
        },

        getGiftMessageHtml: function () {
            var message = this.get('GiftMessage');
            if (message) {
                return '"' + message.replace(/(?:\r\n|\r|\n)/g, '<br/>') + '"';
            }
            return '';
        },

        cancelMessageChanges: function() {
            this.set('GiftMessageEdit', this.get('GiftMessage'));
        },

        hasMessage: function() {
            return !!this.get('GiftMessage');
        },

        hasOccasion: function() {
            return !!this.get('GiftOccasion');
        },

        hasDate: function() {
            return !!this.get('GiftDateDay');
        },

        setGiftDateEdit: function (day, month, year) {
            this.set('GiftDateEditDay', day);
            this.set('GiftDateEditMonth', month);
            this.set('GiftDateEditYear', year);
        },

        _setGiftDate: function (day, month, year) {
            this.set('GiftDateDay', day);
            this.set('GiftDateMonth', month);
            this.set('GiftDateYear', year);
        },

        getGiftDateEditObj: function () {
            return {
                day: this.get('GiftDateEditDay'),
                month: this.get('GiftDateEditMonth'),
                year: this.get('GiftDateEditYear')
            }
        },

        getGiftDateEdit: function () {
            var d = this.getGiftDateEditObj();
            if (d.day && d.month && d.year) {
                return new Date(d.year, d.month - 1, d.day);
            }
            return null;
        },

        getGiftDateObj: function () {
            return {
                day: this.get('GiftDateDay'),
                month: this.get('GiftDateMonth'),
                year: this.get('GiftDateYear')
            }
        },

        getGiftDate: function () {
            var d = this.getGiftDateObj();
            if (d.day && d.month && d.year) {
                return new Date(d.year, d.month - 1, d.day);
            }
            return null;
        },

        getGiftOccasion: function () {
            return this.get('GiftOccasion') || '';
        },

        onGiftDateEditChange: function(cb) {
            this.on('change:GiftDateEditDay change:GiftDateEditMonth change:GiftDateEditYear', cb);
        },

        hasChanges: function () {
            if (this.get('GiftMessageEdit') !== this.get('GiftMessage')) {
                return true;
            }
            if (this.get('GiftOccasionEdit') !== this.get('GiftOccasion')) {
                return true;
            }
            if (this.get('GiftDateEditDay') !== this.get('GiftDateDay')) {
                return true;
            }
            if (this.get('GiftDateEditMonth') !== this.get('GiftDateMonth')) {
                return true;
            }
            if (this.get('GiftDateEditYear') !== this.get('GiftDateYear')) {
                return true;
            }
            return false;
        },

        save: function () {
            var giftDate = this.getGiftDateEdit();
            return api.setGiftParameters({
                giftMessage: this.get('GiftMessageEdit'),
                giftOccasion: this.get('GiftOccasionEdit') || null,
                giftStyle: null,
                giftDate: giftDate && giftDate.format('dd/mm/yyyy') || null
            }).done(this._saved);
        },

        _saved: function(data) {
            var data = data && data.Value || {};
            this._update(data);
            this.trigger('saved', data);
        },

        onSaved: function(cb) {
            this.on('saved', cb);
        },

        _parseGiftDate: function (dateStr) {
            if (dateStr) {
                dateStr = dateStr.replace(/(\d\d)\/(\d\d)\/(\d\d\d\d)/, '$2/$1/$3');
                var tic = Date.parse(dateStr) || null;
                if (tic) {
                    return new Date(tic);
                }
            }
            return null;
        },

        _update: function (data) {
            if (this.get('GiftMessageEdit') === undefined) {
                this.set('GiftMessageEdit', data.GiftMessage);
            }
            if (this.get('GiftOccasionEdit') === undefined) {
                this.set('GiftOccasionEdit', data.GiftOccasion);
            }

            if (data.GiftDateStr) {
                var d = this._parseGiftDate(data.GiftDateStr);
                if (this.get('GiftDateEditDay') === undefined &&
                    this.get('GiftDateEditMonth') === undefined &&
                    this.get('GiftDateEditYear') === undefined) {
                    this.setGiftDateEdit(d.getDate(), d.getMonth() + 1, d.getFullYear());
                }
                this._setGiftDate(d.getDate(), d.getMonth() + 1, d.getFullYear());
            } else {
                this._setGiftDate();
            }

            this.set('GiftMessage', data.GiftMessage);
            this.set('GiftOccasion', data.GiftOccasion);
        }
    });


    app.models = _.extend({
        giftOccasion: new _model()
    }, app.models);

})();